import script from "./MainLayoutMunicipality.vue?vue&type=script&setup=true&lang=js"
export * from "./MainLayoutMunicipality.vue?vue&type=script&setup=true&lang=js"

import "./MainLayoutMunicipality.vue?vue&type=style&index=0&id=64bd275d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64bd275d"]])

export default __exports__